import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField/TextField';
import globalContext from '../../../../config/context';
import Button from '@material-ui/core/Button';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  textField: {
    width: '100%',
    paddingBottom: 10,
  },
  table: {
    minWidth: 550,
  },
  rootPaper: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginBottom: 10,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
}));

const DialogNama = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const [{pencarian}, {setPencarian, setAlert, setLoading}] = useAppContext();

  const {nama, setNama, listNama, onCariNama, onCariNamaButton, handlePressCariNama} = props;

  return (
    <div className={classes.root}>
      <Paper component="div" className={classes.rootPaper}>
        <InputBase
          className={classes.input}
          placeholder="Nama"
          value={nama}
          onChange={(e) => setNama(e.target.value)}
          onKeyDown={handlePressCariNama}
        />
        <IconButton className={classes.iconButton} onClick={onCariNamaButton}>
          <SearchIcon />
        </IconButton>
      </Paper>
      {/*<TextField className={classes.textField} placeholder="Nama" type="text" value={nama} onChange={(e) => setNama(e.target.value)} />*/}
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>NOP</TableCell>
              <TableCell>Nama</TableCell>
              <TableCell>Alamat</TableCell>
              <TableCell>Lokasi</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0 ? listNama.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : listNama).map((row) => (
              <TableRow key={row.nop}>
                <TableCell>{row.nop}</TableCell>
                <TableCell>{row.nm_wp}</TableCell>
                <TableCell>{row.alamat_wp}</TableCell>
                <TableCell>
                  <Button onClick={() => onCariNama(row.nop)} variant="contained" color="primary">
                    Pilih
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={listNama.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default DialogNama;
